<template>
  <div class="news-panel" v-loading="loading">
    <div class="news-header">
      <h2>产业要闻</h2>
      <span>/ Info</span>
    </div>
    <ul class="news-list">
      <li v-for="item in list" :key="item.id">
        <router-link :to="{ name: 'article', params: { id: item.id } }">
          <span class="news-title">{{ item.title }}</span>
          <span class="news-time">{{ formatTime(item.uploadTime) }}</span>
        </router-link>
      </li>
    </ul>
    <div v-if="!loading && list.length === 0" class="empty-state">暂无数据</div>
    <el-pagination
      v-if="total > pageSize"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="page"
      @current-change="loadList"
    ></el-pagination>
  </div>
</template>

<script>
import { articleList } from "@/api/article";

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      loading: false
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList() {
      this.loading = true;
      articleList(this.page, this.pageSize, 0)
        .then(res => {
          this.list = res.list || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      const pad = n => (n < 10 ? "0" + n : "" + n);
      return (
        date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) +
        " " + pad(date.getHours()) + ":" + pad(date.getMinutes())
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.news-panel {
  min-height: 320px;
  padding: 12px;
  background: #ffffff;
  box-sizing: border-box;
}
.news-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 2px solid #0099e2;
  padding-bottom: 8px;
  h2 {
    font-size: 20px;
    color: #333333;
  }
  span {
    color: #999999;
    font-size: 13px;
  }
}
.news-list {
  li {
    border-bottom: 1px solid #f0f0f0;
    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 4px;
      text-decoration: none;
      color: #555555;
      transition: color 0.2s;
      &:hover {
        color: #0099e2;
      }
    }
  }
}
.news-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 12px;
}
.news-time {
  color: #999999;
  font-size: 13px;
  white-space: nowrap;
}
.empty-state {
  padding: 60px 0;
  text-align: center;
  color: #999999;
}
.el-pagination {
  margin-top: 16px;
  text-align: center;
}
@media (max-width: 767.98px) {
  .news-list li a {
    flex-direction: column;
    align-items: flex-start;
  }
  .news-title {
    white-space: normal;
    margin-bottom: 4px;
  }
}
</style>
